import { FC, useEffect } from "react";
import { Menu, Grid, Layout, Popover, Button, Skeleton } from "antd";
import {
  GlobalOutlined,
  PhoneFilled,
  UnorderedListOutlined,
} from "@ant-design/icons";
import classes from "./Header.module.scss";
import { Link, useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { locale, localeData } from "../data/locale";
import { localeTo } from "../utils/helpers";
import cx from "classnames";
import { useAppSelector } from "../utils/hooks";
// images
import logoMini from "../images/logo-mini.png";

const defaultNav = [
  {
    path: "/",
    exact: true,
    name: localeData.home,
  },
  {
    path: "/contracting",
    exact: false,
    name: localeData.cont,
  },
  {
    path: "/equipments",
    exact: false,
    name: localeData.equipments,
  },
  {
    path: "/transport",
    exact: false,
    name: localeData.transport,
  },
  {
    path: "/jobs",
    exact: false,
    name: localeData.jobs,
  },
];
interface Props {
  logo?: string;
  nav?: typeof defaultNav;
  theme?: "dark" | "light";
}
const Header: FC<Props> = ({
  nav = defaultNav,
  theme = "light",
  logo = logoMini,
}) => {
  const settings = useAppSelector(({ settings }) => settings);
  const { pathname, hash } = useLocation();
  const { lg, xl } = Grid.useBreakpoint();


  useEffect(() => {
    // shame solution to go to the top of the page when clicking non hashed link
    if (!hash) window.scrollTo(0, 0);
  }, [hash]);

  const langLink = (
    <a href={locale === "en" ? pathname : "?lang=en"}>
      {locale === "en" ? "عربي" : "English"}
    </a>
  );

  return (
    <Layout.Header className={cx("px-0", classes.header)} data-theme={theme}>
      <div className="container">
        <Link to={localeTo("/")} className={classes.logo}>
          <img src={logo} height="82" width="155" alt="SATC Logo" />
        </Link>
        {/* mobile nav */}
        {!lg && (
          <Popover
            trigger="click"
            placement="bottomRight"
            overlayClassName={classes.popoverMenu}
            content={
              <Menu mode="inline" selectedKeys={[pathname + hash]}>
                {nav.map(({ path, name }) => (
                  <Menu.Item key={path}>
                    <HashLink to={localeTo(path)}>{name}</HashLink>
                  </Menu.Item>
                ))}
                <Menu.Item className={classes.contactItem}>
                  {langLink}
                </Menu.Item>
              </Menu>
            }
          >
            <Button type="link" className={cx(classes.popoverBtn, "push-end")}>
              <UnorderedListOutlined />
            </Button>
          </Popover>
        )}
        {/* desktop nav */}
        {lg && (
          <Menu
            theme={theme}
            mode="horizontal"
            className="w-100"
            selectedKeys={[pathname + hash]}
          >
            {nav.map(({ path, name }) => (
              <Menu.Item key={path} className={classes.navItem}>
                <HashLink to={localeTo(path)}>{name}</HashLink>
              </Menu.Item>
            ))}
            <Menu.Item className={cx(classes.contactItem, "fl-end")}>
              <span className={classes.contactItemIcon}>
                <GlobalOutlined />
              </span>
              {langLink}
            </Menu.Item>
            {xl && (
              <Menu.Item className={cx(classes.contactItem, "fl-end")}>
                <span className={classes.contactItemIcon}>
                  <PhoneFilled />
                </span>
                {settings.status === "loading" && <LoadingSkeleton />}
                {settings.status === "succeeded" && (
                  <a href={`tel:${settings.data?.phone}`}>
                    <span dir="ltr">{settings.data?.phone}</span>
                  </a>
                )}
              </Menu.Item>
            )}
          </Menu>
        )}
      </div>
    </Layout.Header>
  );
};

const LoadingSkeleton: FC = () => {
  return (
    <Skeleton.Input
      style={{
        width: "100px",
        height: "18px",
        verticalAlign: "middle",
        borderRadius: "2px",
      }}
    />
  );
};

export default Header;
